import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useParams } from "react-router-dom";
import JigsawAmazonTabletPage from "./JigsawAmazonTabletPage";

/**
 * Router for `/admin/advertisement/app-screenshot-links/amazon/:app`.
 */
export default function AppAmazonTabletPage() {
    const { app } = useParams();

    if (app === "jigsaw") {
        return <JigsawAmazonTabletPage />;
    }

    return (
        <Box sx={{ p: 3 }}>
            <Typography color="error">
                Amazon Appstore tablet assets are not available for &quot;{app}&quot;. Use jigsaw.
            </Typography>
        </Box>
    );
}
